<ng-container [formGroup]="formParent">
  <!-- TODO ha nincs label.. hidden? vagy valahogy egy külső labellel összekapcsolni? -->
  <div class="label-container">
    <label
      *ngIf="label"
      [for]="id"
      [class.required]="required && !hideRequiredLabel"
      >{{ label | translate }}</label
    >
    <mat-icon *ngIf="labelInfo" class="info-icon" [matTooltip]="labelInfo"
      >info</mat-icon
    >
  </div>
  <div
    class="form-field-container"
    (wheel)="type === 'number' ? $event.stopPropagation() : null"
  >
    <mat-icon matPrefix *ngIf="iconPrefix">{{ iconPrefix }}</mat-icon>
    <img matPrefix *ngIf="svgPrefix" [src]="svgPrefix" />
    <input
      [formControlName]="name"
      [type]="type"
      [(ngModel)]="value"
      [placeholder]="placeholder | translate"
      [id]="id"
      [attr.readonly]="readonly"
      [attr.aria-required]="required ? true : null"
      [min]="min || min === 0 ? min : ''"
      [max]="max || max === 0 ? max : ''"
      [step]="step"
      [class.prefix]="iconPrefix"
      [class.suffix]="iconSuffix"
      [ngClass]="{ 'ps-5': svgPrefix }"
      appLimitDecimalDigits
      [decimals]="maxDecimals"
      [isNumberInput]="type === 'number'"
      [autocomplete]="autocomplete"
      (blur)="onBlur()"
    />
    <mat-icon
      matSuffix
      *ngIf="iconSuffix"
      [style.cursor]="iconSuffixClickable ? 'pointer' : 'normal'"
      (click)="suffixClicked()"
      >{{ iconSuffix }}</mat-icon
    >
    <span class="outer" matSuffix *ngIf="outerSuffixLabel">{{
      outerSuffixLabel | translate
    }}</span>
  </div>

  <ng-container *ngIf="showErrorMessages">
    <mat-error
      id="{{ id }}-required-error"
      *ngIf="ngControl.touched && ngControl?.hasError('required')"
      class="d-flex align-items-center gap-2"
    >
      <mat-icon *ngIf="showRequiredWarningIcon">warning</mat-icon>
      {{ "REQUIRED" | translate }}
    </mat-error>
    <mat-error
      id="{{ id }}-max-error"
      *ngIf="ngControl.touched && ngControl?.hasError('max')"
    >
      {{ "MAX" | translate }} {{ ngControl.errors!["max"]["max"] }}
    </mat-error>
    <mat-error
      id="{{ id }}-min-error"
      *ngIf="ngControl.touched && ngControl?.hasError('min')"
    >
      {{ "MIN" | translate }} {{ ngControl.errors!["min"]["min"] }}
    </mat-error>
    <mat-error
      id="{{ id }}-max-lenght-error"
      *ngIf="ngControl.touched && ngControl?.hasError('maxlength')"
    >
      {{ "MAX" | translate }}
      {{ ngControl.errors!["maxlength"]["requiredLength"] }}
      {{ "NUMBERS" | translate }}
    </mat-error>
    <mat-error
      id="{{ id }}-min-length-error"
      *ngIf="ngControl.touched && ngControl?.hasError('minlength')"
    >
      {{ "MIN" | translate }}
      {{ ngControl.errors!["minlength"]["requiredLength"] }}
      {{ "NUMBERS" | translate }}
    </mat-error>
    <mat-error
      id="{{ id }}-license-number-error"
      *ngIf="ngControl.touched && ngControl?.hasError('exciseLicenseNumber')"
    >
      {{ "FORM_ERROR.LICENSE_NUMBER" | translate }}
    </mat-error>
    <mat-error
      id="{{ id }}-trafik-license-number-error"
      *ngIf="ngControl.touched && ngControl?.hasError('trafikLicenseNumber')"
    >
      {{ "FORM_ERROR.TRAFIK_LICENSE_NUMBER" | translate }}
    </mat-error>
    <mat-error
      id="{{ id }}-ean-number-error"
      *ngIf="ngControl.touched && ngControl?.hasError('eanNumber')"
    >
      {{ "FORM_ERROR.EAN" | translate }}
    </mat-error>
    <mat-error
      id="{{ id }}-ean-number-duplicate-error"
      *ngIf="ngControl.touched && ngControl?.hasError('eanNumberDuplicate')"
    >
      {{ "FORM_ERROR.EAN_DUPLICATE" | translate }}
    </mat-error>
    <mat-error
      id="{{ id }}-global-container-id"
      *ngIf="ngControl.touched && ngControl?.hasError('globalContainerId')"
    >
      {{ "FORM_ERROR.GLOBAL_CONTAINER_ID" | translate }}
    </mat-error>
    <mat-error
      id="{{ id }}-kn-code-error"
      *ngIf="ngControl.touched && ngControl?.hasError('knCode')"
    >
      {{ "FORM_ERROR.KN_CODE" | translate }}
    </mat-error>
    <mat-error
      id="{{ id }}-not-embeddable-error"
      *ngIf="ngControl.touched && ngControl?.hasError('notEmbeddable')"
    >
      {{ "FORM_ERROR.VIDEO_LINK" | translate }}
    </mat-error>
    <mat-error
      id="{{ id }}-email-error"
      *ngIf="ngControl.touched && ngControl?.hasError('invalidEmail')"
    >
      {{ "FORM_ERROR.EMAIL" | translate }}
    </mat-error>
    <mat-error
      id="{{ id }}-tax-number-error"
      *ngIf="ngControl.touched && ngControl?.hasError('taxNumber')"
    >
      {{ "FORM_ERROR.TAX" | translate }}
    </mat-error>
    <mat-error
      id="{{ id }}-phone-number-error"
      *ngIf="ngControl.touched && ngControl?.hasError('phoneNumber')"
    >
      {{ "FORM_ERROR.PHONE" | translate }}
    </mat-error>
    <mat-error
      id="{{ id }}-weak-password-error"
      *ngIf="ngControl.touched && ngControl?.hasError('weakPassword')"
    >
      {{ "FORM_ERROR.WEAK_PASSWORD" | translate }}
    </mat-error>
  </ng-container>
</ng-container>
